import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
// remove associations positioning here,
// eventually remove it from the baked in render method to make this cleaner
const TrayWrapper = styled.div.withConfig({
  displayName: "RenderTray__TrayWrapper",
  componentId: "aottoe-0"
})(["flex-grow:1;display:flex;justify-content:flex-end;.associations-positioning-wrapper{position:relative !important;right:auto !important;margin:", " !important;}"], ({
  theme
}) => theme.space['0']);
const RenderTrayPassthrough = ({
  renderTray
}) => {
  // @bend-expect trellis-tokenized
  return /*#__PURE__*/_jsx(TrayWrapper, {
    children: renderTray && renderTray({})
  });
};
export default RenderTrayPassthrough;